import script from "./DocumentSurveys.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentSurveys.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentSurveys.vue?vue&type=style&index=0&id=89e76cfe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e76cfe"]])

export default __exports__